import { fontsConfig as i, typographyRecipe as o } from "@huspy/briks-core";
import { defineSlotRecipe as r } from "@pandacss/dev";
import { anatomy as t } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/combobox/dist/index.mjs";
const f = r({
  className: "combobox",
  slots: t.keys(),
  base: {
    root: {
      fontFamily: i.sansSerif.family
    },
    input: {
      borderRadius: "full",
      fontFamily: i.sansSerif.family,
      ...o.size["sans-serif"].lg,
      ...o.weight.regular,
      fontSize: `${o.size["sans-serif"].lg.fontSize}!`
    },
    trigger: {
      margin: "auto 0"
    },
    clearTrigger: {
      position: "absolute",
      right: "4",
      top: "0",
      bottom: "0",
      margin: "auto 0",
      color: "fg-tertiary"
    }
  }
});
export {
  f as combobox
};
